import { BusinessProfileEditor } from '@/components/profile/BusinessProfileEditor';

type CreateProfilePageProps = {
  onSuccess?: () => void;
};

export default function CreateProfilePage({ onSuccess }: CreateProfilePageProps) {
  return (
    <div className="space-y-6">
      <BusinessProfileEditor onSuccess={onSuccess} />
    </div>
  );
}
